module.exports = __webpack_public_path__ + "img/break_end_btn.2edd9902.png";